const formFields = [
  {
    name: "FNAME",
    type: "text",
    placeholder: "Your first name",
    format: "",
    required: true,
    halfWidth: false,
    emoji: "👋",
  },
  {
    name: "EMAIL",
    type: "email",
    placeholder: "Your email address",
    required: true,
    halfWidth: false,
    emoji: "👍",
  },
  {
    name: "PHONE",
    type: "tel",
    placeholder: "Your mobile",
    required: false,
    halfWidth: false,
    emoji: "🤙",
  },

  // GDPR FIELDS
  {
    name: "gdpr[29433]",
    type: "checkbox",
    // label: 'Email',
    required: true,
  },
  {
    name: "gdpr[29441]",
    type: "checkbox",
    // label: 'Telephone',
    required: false,
  },

  // Hidden Bot Field
  {
    type: "bot",
    name: "b3134",
    tabindex: "-1",
  },
  // {
  //   name: "terms",
  //   type: "checkbox",
  //   label: "I agree to be contacted about the Fufil app",
  //   // href: "/legal",
  //   required: true,
  //   halfWidth: false,
  // },
  // {
  //   name: "testing",
  //   type: "checkbox",
  //   label: "I can help improve the app by testing it or creating content",
  //   // href: "/legal",
  //   required: false,
  //   halfWidth: false,
  // },
  // {
  //   name: "lastName",
  //   type: "text",
  //   placeholder: "Last Name",
  //   format: '',
  //   required: true,
  //   halfWidth: true
  // },
  // {
  //   name: "phoneType",
  //   type: "select",
  //   placeholder: "Mobile operating system",
  //   options: [
  //     { value: "android", displayValue: "Android" },
  //     { value: "ios", displayValue: "iOS" },
  //     { value: "other", displayValue: "Other" },
  //   ],
  //   required: true,
  //   halfWidth: false,
  // },
  // {
  //   name: "idea",
  //   type: "textarea",
  //   placeholder: "Tell us a little bit about your project or idea",
  //   format: '',
  //   required: true,
  //   halfWidth: false
  // },
  // {
  //   name: "telephone",
  //   format: "(+44) ##########",
  //   type: "tel",
  //   placeholder: "(+44) Telephone Number",
  //   required: true,
  // },
  // servicing: {
  //   name: "servicing",
  //   type: "checkbox",
  //   label: "Receive monthly updates",
  //   required: false,
  // },
  // marketing: {
  //   name: "marketing",
  //   type: "checkbox",
  //   label: "Receive promotional material",
  //   required: false,
  // },
  // dob: {
  //   name: "dob",
  //   format: "##/##/####",
  //   type: "text",
  //   placeholder: "DD/MM/YYYY",
  //   mask: ["D", "D", "M", "M", "Y", "Y", "Y", "Y"]
  // }
]

export default formFields

// <!-- Begin Mailchimp Signup Form -->
// <div id="mc_embed_signup">
// <form action="https://app.us8.list-manage.com/subscribe/post?u=d341ba14768feb20f12908a47&amp;id=b0d3956481" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
//     <div id="mc_embed_signup_scroll">
// 	<h2>Subscribe</h2>
// <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
// <div class="mc-field-group">
// 	<label for="mce-EMAIL">Email Address  <span class="asterisk">*</span>
// </label>
// 	<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
// </div>
// <div class="mc-field-group">
// 	<label for="mce-FNAME">First Name  <span class="asterisk">*</span>
// </label>
// 	<input type="text" value="" name="FNAME" class="required" id="mce-FNAME">
// </div>
// <div class="mc-field-group size1of2">
// 	<label for="mce-PHONE">Phone Number </label>
// 	<input type="text" name="PHONE" class="" value="" id="mce-PHONE">
// </div>
// <div class="mc-field-group">
// 	<label for="mce-REFERRAL">Referral Id </label>
// 	<input type="text" value="" name="REFERRAL" class="" id="mce-REFERRAL">
// </div>
// <div class="mc-field-group">
// 	<label for="mce-REFERREDBY">Referred By </label>
// 	<input type="text" value="" name="REFERREDBY" class="" id="mce-REFERREDBY">
// </div>
// <div id="mergeRow-gdpr" class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
//     <div class="content__gdpr">
//         <label>Marketing Permissions</label>
//         <p>Please select all the ways you would like to hear from Agaia:</p>
//         <fieldset class="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">
// 		<label class="checkbox subfield" for="gdpr_29433"><input type="checkbox" id="gdpr_29433" name="gdpr[29433]" value="Y" class="av-checkbox gdpr"><span>Email</span> </label><label class="checkbox subfield" for="gdpr_29441"><input type="checkbox" id="gdpr_29441" name="gdpr[29441]" value="Y" class="av-checkbox gdpr"><span>Telephone</span> </label>
//         </fieldset>
//         <p>You can unsubscribe at any time by clicking the link in the footer of our emails. For information about our privacy practices, please visit our website.</p>
//     </div>
//     <div class="content__gdprLegal">
//         <p>We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing. <a href="https://mailchimp.com/legal/" target="_blank">Learn more about Mailchimp's privacy practices here.</a></p>
//     </div>
// </div>
// 	<div id="mce-responses" class="clear">
// 		<div class="response" id="mce-error-response" style="display:none"></div>
// 		<div class="response" id="mce-success-response" style="display:none"></div>
// 	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
//     <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_d341ba14768feb20f12908a47_b0d3956481" tabindex="-1" value=""></div>
//     <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
//     </div>
// </form>
// </div>

// <!--End mc_embed_signup--></div>
